/**
 * 认证页面共享表单验证函数
 * Element UI form validator 格式：(rule, value, callback) => {}
 */

export const sanitizeDigits = (value) => (value || '').replace(/\D/g, '');

export const sanitizeAlphaNumeric = (value) => (value || '').replace(/[^a-zA-Z0-9]/g, '');

export const sanitizeCompatibleLoginName = (value) => (value || '').replace(/[^\u4e00-\u9fa5a-zA-Z0-9_]/g, '');

export const trimOuterWhitespace = (value) => (typeof value === 'string' ? value.trim() : '');

export const normalizeTenantKeyInput = (value) => trimOuterWhitespace(value).toLowerCase();

export const PHONE_MIN_LENGTH = 7;

export const PHONE_MAX_LENGTH = 15;

export const PHONE_PATTERN = /^\+?[1-9]\d{6,14}$/;

export const REGISTER_ACCOUNT_MIN_LENGTH = PHONE_MIN_LENGTH;

export const REGISTER_ACCOUNT_MAX_LENGTH = PHONE_MAX_LENGTH;

export const isAlphaNumeric = (value) => /^[a-zA-Z0-9]+$/.test(value || '');

export const isPhoneLike = (value) => PHONE_PATTERN.test(value || '');

export const isPhoneValid = (value) => PHONE_PATTERN.test(value || '');

export const isRegisterAccountLengthValid = (value) =>
	(value || '').length >= REGISTER_ACCOUNT_MIN_LENGTH && (value || '').length <= REGISTER_ACCOUNT_MAX_LENGTH;

export const isPasswordValid = (value) => /^[a-zA-Z0-9]{5,20}$/.test(value || '');

export const isSmsCodeValid = (value) => /^\d{6}$/.test(value || '');

// 手机号校验
export const validatePhone = (rule, value, callback) => {
	if (!value) {
		return callback(new Error('请输入手机号码'));
	}
	if (!isPhoneValid(value)) {
		return callback(new Error('请输入7-15位国际手机号'));
	}
	callback();
};

// 用户名非空校验
export const validateUsername = (rule, value, callback) => {
	if (!value) {
		return callback(new Error('请输入用户名'));
	}
	if (!isAlphaNumeric(value)) {
		return callback(new Error('用户名仅支持字母和数字'));
	}
	callback();
};

export const validateRegisterUsername = (rule, value, callback) => {
	if (!value) {
		return callback(new Error('请输入用户名'));
	}
	if (!isAlphaNumeric(value)) {
		return callback(new Error('用户名仅支持字母和数字'));
	}
	if (!isRegisterAccountLengthValid(value)) {
		return callback(new Error('账号长度必须在7-15位之间'));
	}
	if (isPhoneLike(value)) {
		return callback(new Error('用户名不能使用手机号'));
	}
	callback();
};

export const validateLoginName = (rule, value, callback) => {
	if (!value) {
		return callback(new Error('请输入账号'));
	}
	if (sanitizeCompatibleLoginName(value) !== value) {
		return callback(new Error('账号仅支持中文、字母、数字和下划线'));
	}
	callback();
};

export const validateExistingPassword = (rule, value, callback) => {
	if (value === '') {
		return callback(new Error('请输入密码'));
	}
	callback();
};

export const validateCaptchaCode = (rule, value, callback) => {
	if (!value) {
		return callback(new Error('请输入验证码'));
	}
	if (!isAlphaNumeric(value)) {
		return callback(new Error('验证码仅支持字母和数字'));
	}
	callback();
};

export const validateSmsCode = (rule, value, callback) => {
	if (!value) {
		return callback(new Error('请输入短信验证码'));
	}
	if (!isSmsCodeValid(value)) {
		return callback(new Error('短信验证码需为6位数字'));
	}
	callback();
};

// 新密码校验
export const validatePassword = (rule, value, callback) => {
	if (value === '') {
		return callback(new Error('请输入密码'));
	}
	if (!isPasswordValid(value)) {
		return callback(new Error('密码需为5-20位字母或数字'));
	}
	callback();
};

// 确认密码校验，接受一个获取密码值的函数
export const createConfirmPasswordValidator = (getPassword) => {
	return (rule, value, callback) => {
		if (value === '') {
			return callback(new Error('请输入确认密码'));
		}
		if (!isPasswordValid(value)) {
			return callback(new Error('密码需为5-20位字母或数字'));
		}
		if (value != getPassword()) {
			return callback(new Error('两次密码输入不一致'));
		}
		callback();
	};
};
